export default __webpack_public_path__ + "a17f02a7969a999bdef7ee2e3995dd1f.svg";